import RoleSelection from '@/components/_core/ui/role-selection';
import { mapGetters, mapState } from 'vuex';

export default {
  components: {
    RoleSelection
  },
  data() {
    return {
      dialog: false
    };
  },
  computed: {
    ...mapGetters({
      isImpersonated: '_core/auth/isImpersonated'
    }),
    ...mapState({
      currentRights     : (state) => state._core.auth.currentRole,
      tenantsRights     : (state) => state._core.auth.tenantsRights,
      applicationsRoles : (state) => state._core.auth.applicationsRoles,
      owner             : (state) => state._core.application.owner
    }),
    nivelaccess() {
      if (this.currentRights?.ies?.name) {
        return `${this.$t('_core.roleSelection.ies')}: ${this.currentRights.ies.name}`;
      }
      if (this.currentRights?.tenant?.name) {
        return `${this.$t('_core.roleSelection.tenant')}: ${this.currentRights.tenant.name}`;
      }
      return '';
    },
    role() {
      return this.currentRights?.role?.alias ? this.currentRights?.role?.name : '';
    },
    existMoreRoles() {
      switch (this.owner) {
        case null:
          return this.applicationsRoles?.roles?.length > 1 || this.tenantsRights.find(item => item.roles.length) || this.tenantsRights.find(tenant => tenant?.ies.find(item => item.roles.length));
        case 'tenant':
          return this.tenantsRights[0]?.roles?.length > 1 || this.tenantsRights[0]?.ies.find(item => item.roles.length);
        case 'ies':
          return this.tenantsRights[0]?.ies[0].roles?.length > 1;
      }
    }
  },
  methods: {
    onChange(e) {
      e.stopPropagation();
      this.dialog = !this.dialog;
    }
  },
  watch: {
    dialog() {
      this.$emit('menu-close');
    },
    currentRights() {
      this.dialog = false;
    }
  }

};
